import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import get from 'lodash/get';

import DynamicProperties from './DynamicProperties';
import {
  getAMLSCommonDynamicPropertiesCategories,
  getAMLSCommonDynamicProperties,
  resetAMLSCommonDynamicProperties,
  putAMLSCommonDynamicPropertiesUpdate,
  putAMLSCommonDynamicPropertiesUpdateReset
} from '../../../redux/actions/common';

const mapStateToProps = (state) => {
  return {
    dynPropCategories: get(state, 'amlsCommon.dynPropCategories.data', []),
    dynProperties: get(state, 'amlsCommon.dynProperties.data', {}),
    dynPropertiesLoading: get(
      state,
      'amlsCommon.dynProperties.isLoading',
      false
    ),
    dynPropertiesUpdateSuccess: get(
      state,
      'amlsCommon.dynPropertiesUpdate.isSuccess',
      false
    ),
    dynPropertiesUpdateData: get(
      state,
      'amlsCommon.dynPropertiesUpdate.data',
      null
    ),
    dynPropertiesUpdateError: get(
      state,
      'amlsCommon.dynPropertiesUpdate.error',
      null
    )
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getAMLSCommonDynamicPropertiesCategories,
        getAMLSCommonDynamicProperties,
        resetAMLSCommonDynamicProperties,
        putAMLSCommonDynamicPropertiesUpdate,
        putAMLSCommonDynamicPropertiesUpdateReset
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DynamicProperties);
